export default "__VITE_ASSET__BkDb3gWf__"